/*
 * @Description: mark
 * @Author: wangwangwang
 * @Date: 2020-11-25 17:29:53
 * @LastEditors: wangwangwang
 * @LastEditTime: 2020-11-30 16:54:22
 */

/*混凝土*/
export const queryPage2 = "/icps/system/sign/intelligent/tripleReport/beton/get_triple_report_page";
export const saveOrUpdate2 = '/icps/system/sign/intelligent/tripleReport/beton/save_or_update_report'
/*原物料*/
export const queryPage1 = "/icps/system/sign/intelligent/tripleReport/raw/get_triple_report_page";
export const saveOrUpdate1 = '/icps/system/sign/intelligent/tripleReport/raw/save_or_update_report'

import request from '@/utils/request'
export function get_report_list(params) {
  return request({
    url: '/icps/system/sign/intelligent/tripleReport/file/get_report_list',
    method: 'get',
    params
  })
}
export function saveData(data) {
  return request({
    url: '/icps/system/sign/intelligent/tripleReport/raw/save_or_update_report',
    method: 'post',
    data
  })
}
export function saveData2(data) {
  return request({
    url: '/icps/system/sign/intelligent/tripleReport/beton/save_or_update_report',
    method: 'post',
    data
  })
}
